export const getImageUrl = (): string =>
  'https://cdn.sanity.io/images/inntox6v/production/1151f6e902734701d53626228f3baf82e616840f-122x32.svg';
